import { getContrast } from 'polished';
import { ThemeWebColors } from 'styled-components/macro';
import defaultTheme from 'theme/defaultTheme';

export const isLowContrast = (color: string, bgColor: string = '#fff'): boolean => {
    try {
        const contrast = getContrast(color, bgColor);
        return contrast < 1.25;
    } catch (error) {
        return true; // We should not send in color strings that break here but falls back to showing border in case of strange or broken color string.
    }
};

export const isThemeColor = (color: string | PropertyKey): color is keyof ThemeWebColors => {
    return color in defaultTheme.webColors;
};

export const isColorDark = (color: string): boolean => {
    const hex = color.replace('#', '');
    if (hex.length !== 6) return false;
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
}